/* Recently viewed products (moved from sections/recently-viewed.liquid). */
(function () {
  function init(root) {
      if (!root || root.dataset.rvReady === 'true') return;
      root.dataset.rvReady = 'true';

      var KEY = 'recently-viewed';
      var ids = [];
      try {
        ids = JSON.parse(window.localStorage.getItem(KEY) || '[]');
        if (!Array.isArray(ids)) ids = [];
      } catch (e) {
        ids = [];
      }

      var currentId = root.getAttribute('data-product-id');
      var max = parseInt(root.getAttribute('data-max-products'), 10) || 4;

      if (currentId) {
        var index = ids.indexOf(currentId);
        if (index !== -1) ids.splice(index, 1);
        ids.unshift(currentId);
        try {
          window.localStorage.setItem(KEY, JSON.stringify(ids.slice(0, 50)));
        } catch (e) {}
      }

      var others = ids.filter(function (id) { return id !== currentId; }).slice(0, max);
      if (!others.length) return;

      var query = others.map(function (id) { return 'id:' + id; }).join(' OR ');
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var url = base + 'search?type=product&q=' + encodeURIComponent(query) + '&section_id=recently-viewed';

      fetch(url)
        .then(function (res) { return res.ok ? res.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var wrapper = document.createElement('div');
          wrapper.innerHTML = html;
          var grid = wrapper.querySelector('[data-rv-results]');
          if (!grid || !grid.children.length) return;
          root.querySelector('[data-rv-output]').appendChild(grid);
          root.hidden = false;
        })
        .catch(function (err) { console.error('Recently viewed fetch failed:', err); });
  }

  function initAll() { document.querySelectorAll('[data-rv]').forEach(init); }
  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
